// Design tokens for the Elliott-led lesson redesign.
// Values mirror the Dosen DS variables pulled from Figma (file TCnaeNWcSV0AhKVt2pVzMG).
// Kept as a local map so the feature reads cleanly; swap for global CSS vars at cutover.

export const elliottTokens = {
  // Fills
  bg: '#0F0F0F', // Fill/background
  surface: '#1C1C1C', // Fill/tooltip-fade — raised surfaces (cards, input)
  surfaceHover: '#151515',
  cardOrange: '#661F0F', // Fill/Chat/Card/card-orange — takeaway / accent fills

  // Brand
  brandDark: '#F15A26', // orange/700, Brand/dark
  brandLight: '#F79420', // orange/500, Brand/light

  // Text
  textPrimary: '#FDFDFD', // Text/text-primary
  textSecondary: '#B6B6B6', // Text/text-secondary
  textTertiary: '#868686', // Text/text-tertiary

  // Strokes
  borderDim: '#2A2A2A', // Stroke/Border/border-dim
  borderContrast: '#565656', // Stroke/Card/card-contrast-highlight, disabled

  // Status (completed / in-progress / to-do)
  success: '#00972D', // green — completed lessons/modules + correct MCQ
  successDim: '#16351F', // muted green fill for explainer / correct rows
  error: '#EF4444', // incorrect MCQ selection

  // Nav highlighted-tab gradients ("shine" + "brandy"), exact from Figma left-nav.
  navGreenFill: 'linear-gradient(90deg, rgba(26,242,107,0.68) 0%, rgba(13,140,56,0.22) 100%)',
  navBrandyFill: 'linear-gradient(90deg, rgba(255,128,20,0.9) 0%, rgba(204,71,10,0.35) 100%)',
  navGreenText: '#E0FAEB',
  navBrandyText: '#FFF2E0',

  // "Brandy" gradient text — vertical, both stops vivid so text never fades into the dark bg.
  brandyTextGradient: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
  greenTextGradient: 'linear-gradient(180deg, #1AF26B 0%, #0D8C38 100%)',

  // Shape / type
  radius: 8, // radius/border_radius_8
  bodySize: 16, // Font family/Size/Body Regular
  bodyLineHeight: 24 // Font family/Line height/Body Regular
} as const;

export type LessonStepKey = 'content' | 'application' | 'simulation' | 'quiz';

export type StepStatus = 'upcoming' | 'active' | 'complete';
